export enum IDynamicTableTypes {
  DYNAMIC_TABLE_REQUEST = '@dynamicTable/DYNAMIC_TABLE_REQUEST',
  DYNAMIC_TABLE_SUCCESS = '@dynamicTable/DYNAMIC_TABLE_SUCCESS',
  DYNAMIC_TABLE_FAILURE = '@dynamicTable/DYNAMIC_TABLE_FAILURE',
}

export interface IDynamicTableRequestAction {
  type: typeof IDynamicTableTypes.DYNAMIC_TABLE_REQUEST;
  payload: {
    name: string;
    orgId: string;
  };
}
export interface IDynamicTableSuccessAction {
  type: typeof IDynamicTableTypes.DYNAMIC_TABLE_SUCCESS;
  payload: {
    dynamicTable: Array<string>;
  };
}
export interface IDynamicTableFailureAction {
  type: typeof IDynamicTableTypes.DYNAMIC_TABLE_FAILURE;
}

export type IDynamicTableActionsType =
  | IDynamicTableRequestAction
  | IDynamicTableSuccessAction
  | IDynamicTableFailureAction;

export interface IDynamicTableState {
  loading: boolean;
  dynamicTableColumns: any;
}

export enum StatusOption {
  REQUEST = 'request',
  SUCCESS = 'success',
  FAILURE = 'failure',
}
